(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc-bespoke-concept-to-creation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bespoke-project-portfolio')) {
    // One delegated inquiry handler covers both bespoke CTAs, including
    // sections re-rendered by the editor. No global scroll style is changed.
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.ctrlKey || event.metaKey || event.shiftKey || event.altKey
      ) return;

      const link = event.target.closest(
        'a.gc-bh__button, a[data-inquiry-scroll]'
      );
      if (!link || !link.closest('.gc-bh, bespoke-project-portfolio')) return;
      if (link.hasAttribute('download')) return;
      if (link.target && link.target !== '_self') return;

      let destination;
      let target;
      try {
        destination = new URL(link.href, window.location.href);
        if (
          destination.origin !== window.location.origin ||
          destination.pathname !== window.location.pathname ||
          destination.search !== window.location.search ||
          !destination.hash
        ) return;
        target = document.getElementById(
          decodeURIComponent(destination.hash.slice(1))
        );
      } catch (error) {
        return;
      }
      if (!target || !target.matches('form') || !target.getClientRects().length) return;

      event.preventDefault();
      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
        target.addEventListener('blur', () => target.removeAttribute('tabindex'), {
          once: true
        });
      }
      target.focus({ preventScroll: true });
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'instant' : 'smooth',
        block: 'start'
      });
    });

    customElements.define(
      'bespoke-project-portfolio',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.toggle = this.querySelector('[data-portfolio-toggle]');
          this.panel = this.querySelector('[data-portfolio-panel]');
          this.label = this.querySelector('[data-portfolio-label]');
          this.arrow = this.querySelector('[data-portfolio-arrow]');

          this.onClick = (event) => {
            if (!(event.target instanceof Element)) return;

            const toggle = event.target.closest('[data-portfolio-toggle]');
            if (toggle && this.contains(toggle) && this.panel) {
              this.setExpanded(this.panel.hidden);
              return;
            }
          };

          this.onBlockSelect = (event) => {
            const target = event.target;
            if (
              this.panel &&
              target instanceof Element &&
              this.panel.contains(target)
            ) {
              this.setExpanded(true);
            }
          };

          this.addEventListener('click', this.onClick);
          document.addEventListener(
            'shopify:block:select',
            this.onBlockSelect
          );

          if (this.toggle && this.panel) {
            this.setExpanded(false);
            this.toggle.hidden = false;
          }
        }

        disconnectedCallback() {
          if (!this.initialized) return;

          this.removeEventListener('click', this.onClick);
          document.removeEventListener(
            'shopify:block:select',
            this.onBlockSelect
          );

          this.initialized = false;
        }

        setExpanded(expanded) {
          if (!this.toggle || !this.panel) return;

          this.panel.hidden = !expanded;
          this.toggle.setAttribute('aria-expanded', String(expanded));

          if (this.label) {
            this.label.textContent = expanded
              ? this.toggle.dataset.closeLabel
              : this.toggle.dataset.openLabel;
          }

          if (expanded) {
            this.panel
              .querySelectorAll('img[data-portfolio-src]')
              .forEach((image) => {
                image.srcset = image.dataset.portfolioSrcset;
                image.src = image.dataset.portfolioSrc;
                image.removeAttribute('data-portfolio-srcset');
                image.removeAttribute('data-portfolio-src');
              });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
